import React, { useState, useRef, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import "./ModuleContent.scss";
import ModuleListCard from "./ModuleListCard";
import { TextField } from "@material-ui/core";
import {
  DropDownField,
  SearchTextField,
  TextFields,
  SearchTextFieldTemplate
} from "../../ResuableComponent/CustomModal/TextFields/TextFields";
import { Modal } from "react-bootstrap";
import { getmmModules, searchForDetails, getModuleCardDetails } from "../../../services/apis";
import CircularProgressBar from "../../../utils/CircularProgressBar";
import NoResultsFound from "../../../images/Noresults.svg";
import NoModuleFound from "../../../images/NoModuleFound.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import SelectedModuleModal from "./SelectedModuleModal";
import ModuleContentCardDetailsModal from "./ModuleContentCardDetailsModal";
import CommonAutocompleteDropdown from "../../ResuableComponent/CustomModal/DropdownWithFilter/CommonAutocompleteDropdown";
import SelectAutoComplete from "../../ResuableComponent/SelectAutoComplete/SelectAutoComplete";
import SelectTemplateCard from "./SelectTemplateCard";
import CrossIcon from "../../../images/clearTextIcon.svg";

import ModuleView from "../ModulePreview/ModuleView";

const ModuleContent = ({
  setActiveNextButton,
  selectedModuleIds,
  setSelectedModuleIds,
  setSwitchCustomJs,
  switchCustomJs,
  setModuleDetails,
  brands,
  appData,
  market,
  from,
  basicDetail,
  modulePage,
  setPayloadData,
  payloadData,
  setModulesSelected,
  modulesSelected,
  closeTootltipTitle,
  closeTootltip,
}) => {
  const cardRef = useRef();
  const cardBtnRef = useRef();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedCard, setSelectedCard] = useState([]);
  const [moduleCardList, setModuleCardList] = useState([]);
  const [page, setPage] = useState(0);
  const [selectedNextModuleList, setSelectedNextModuleList] = useState([]);
  // const [selectedModuleIds, setSelectedModuleIds] = useState([]);
  const [disabledModules, setDisabledModules] = useState([]);
  const [disabledModulesOptional, setDisabledOptionalModules] = useState([]);
  const [disabledMustExistModules, setDisabledMustExistModules] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const [enableResetBtn, setEnableResetBtn] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [cradDetails, setCardDetails] = useState({});
  const [storedData, setStoredData] = useState({});
  const [hasMoreTemplate, setHasMoreTemplate] = useState(false)
  const [skipRange, setSkipRange] = useState(0)
  const [showFetchedResults, setshowFetchedResults] = useState([]);
  const [searchTextTemplate, setSearchTextTemplate] = useState("");
  const [templateSelected, setTemplatedSelected] = useState([]);
  const [searchedData, setSearchedData] = useState([]);
  const limit = 100;
  const [moduleData, setModuleData] = useState([]);

  const infinteScrollRef = useRef();
  const prevSearchText = useRef(null);
  const prevSearchTextTemplate = useRef(null);
  
  /* const primaryCountry =
    from === "edit"
      ? market.find((li) => li._id === appData.deckId.market)
      : market
      ? market
      : "";
  const primaryProduct =
    from === "edit"
      ? brands.find((li) => li._id === appData.deckId.brand)
      : brands
      ? brands
        : ""; */
  let localdata = JSON.parse(localStorage.getItem("basicEdetailData")) || {};
  if (from === "edit") {
    localdata['brand'] = brands.find((li) => li._id === appData?.deckId?.brand);
    localdata['market'] = market.find((li) => li._id === appData?.deckId?.market)
  }
  
  useEffect(() => {
    if (from !== 'edit') {
      setSearchTextTemplate('')
      setSearchText('')
      setTemplatedSelected([])
     // fetchMoreTemplate('all', 0, false, false)
      setPayloadData({ brand: localdata?.brand?._id, market: localdata?.market?._id, name: localdata?.edetailName, type:localdata?.type, docNumber:localdata?.docNumber, indication: localdata?.indication });
    }
    
   },[modulePage]);

  useEffect(() => {
    if (searchText.trim() === "" && prevSearchText.current !== "") {
      getModuleContentDetails();
      setEnableResetBtn(false);
      // setLoading(true);
    }
  }, [searchText.trim().length > 0]);

  useEffect(() => {
    const getModuleContentDetailss = () => {
      const payload = {
        productName: localdata?.brand?.name,
        countryName: localdata?.market?.name,
        searchText: searchText,
        topicName: "",
        subtopicName: "",
        segmentNames: [],
        page: page,
      };

      prevSearchText.current = searchText;
  
      getmmModules(payload, (response, err, ErrorCode) => {
        setLoading(true);
        if (err) {
          setLoading(false);
          console.log("search module error", err);
          // toastError();
        } else {
          
          const data = response?.data?.data || [];
          const listData = data.filter(li => li.mlrStatus === 'Available for Use');
          setModuleCardList([...moduleCardList, ...listData]);
          // setModuleCardList(data);
          setModuleDetails(listData);
          setModuleDetails([...moduleCardList, ...listData]);
          if(response.data.totalElements <= [...moduleCardList, listData].length) {
            setHasMore(false);
          } else if(response.data.totalElements >= [...moduleCardList, listData].length) {
            setHasMore(true);
          }
          setLoading(false);
        }
      });
    };
    getModuleContentDetailss();
  }, []);

  const getModuleContentDetails = () => {
    setPage(0);
    const payload = {
      productName: localdata?.brand?.name,
      countryName: localdata?.market?.name,
      searchText: searchText,
      topicName: "",
      subtopicName: "",
      segmentNames: [],
      page: 0,
    };

    prevSearchText.current = searchText;

    getmmModules(payload, (response, err, ErrorCode) => {
      setLoading(true);
      if (err) {
        setLoading(false);
        console.log("search module error", err);
        // toastError();
      } else {
        const data = response?.data?.data || [];
        const listData = data.filter(li => li.mlrStatus === 'Available for Use');
        setModuleCardList(listData);
        setModuleDetails([...moduleCardList, ...listData]);
        // setModuleDetails(data);
        if(response.data.totalElements <= [...moduleCardList, listData].length) {
          setHasMore(false);
        } else if(response.data.totalElements >= [...moduleCardList, listData].length) {
          setHasMore(true);
        }
        setSearchedData(listData);
        setLoading(false);
      }
    });
  };

  const handleViewClick = (e, list) => {
     e.stopPropagation();

    getModuleCardDetails(list.id, (response, err, errorCode) => {
                setLoading(true);
                if (err) {
                    console.log(err);
                    setLoading(false);
                } else {
                    let resp = response.data;
                    setLoading(false);
                    setCardDetails(resp);
                    setIsPopupVisible(!isPopupVisible);
                    
                }
            })
   

    
  };


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        cardBtnRef.current &&
        !cardBtnRef.current.contains(e.target) &&
        cardRef.current &&
        !cardRef.current.contains(e.target)
      ) {
        setIsPopupVisible(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleCardClick = (moduleId) => {
    if (disabledModules.includes(moduleId)) {
      return;
    }
    if (disabledMustExistModules.includes(moduleId)) {
      return;
    }

    if (selectedModuleIds.includes(moduleId)) {
      setSelectedModuleIds(selectedModuleIds.filter((id) => id !== moduleId));
      from !== 'edit' && setModulesSelected(modulesSelected.filter((item) => item.id !== moduleId));
    } else {
      setSelectedModuleIds([...selectedModuleIds, moduleId]);
      const list = moduleCardList.find((card)=> card.id == moduleId)
    from !== 'edit' && setModulesSelected([...modulesSelected, list])
    }
    
  };

  // Handling border color of the card
  const getModuleStyle = (moduleId) => {
    const isSelected = selectedModuleIds.includes(moduleId);
    const isDisabled = disabledModules.includes(moduleId);
    const disabledMustExist = disabledMustExistModules.includes(moduleId);
    if (selectedModuleIds.length > 0) {
      setActiveNextButton(true);
    } else {
      setActiveNextButton(false);
    }
    if (isSelected) {
      return { border: "1px solid #DCE2EA", cursor: "pointer" }; // Selected card
    }

    if (isDisabled) {
      return { border: "1px dashed #E32B35", cursor: "not-allowed" }; // Disabled card
    }
    if (disabledMustExist) {
      return { border: "1px solid #DDDFDD", cursor: "default" }; // Default card style
    }
  };

  React.useEffect(() => {
    const disabled = [];
    const disabledMustExist = [];
    selectedModuleIds.forEach((moduleId) => {
      const module = moduleData?.find((mod) => mod.id === moduleId);
      if (module) {
        const canNotExistModule = module.moduleBusinessRules.filter(
          (rule) => rule.ruleCondition === "CannotExistWith"
        );
        const optionalModule = module.moduleBusinessRules.filter(
          (rule) => rule.ruleCondition === "Optional"
        );
        const mustExistModule = module.moduleBusinessRules.filter(
          (rule) => rule.ruleCondition === "MustExistWith"
        );
        if (canNotExistModule.length > 0) {
          canNotExistModule?.forEach((rule) => {
            if (!selectedModuleIds.includes(rule.targetModuleId)) {
              disabled.push(rule.targetModuleId);
            }
          });
        }
        if (mustExistModule.length > 0) {
          mustExistModule?.forEach((rule) => {
            if (!selectedModuleIds.includes(rule.targetModuleId)) {
              disabledMustExist.push(rule.targetModuleId);
            }
          });
        }
      }
    });
    setDisabledModules([...new Set(disabled)]);
    setDisabledMustExistModules([...new Set(disabledMustExist)]);
  }, [selectedModuleIds, moduleCardList]);

  // Setting value in Search state
  const searchfieldsHandler = (e) => {
    setSearchText(e.target.value);
  };

  // Clear Search Field Handler
  const cancelSearchField = () => {
    setSearchText("");
    setEnableResetBtn(false); // Disabling reset button, when user click on x icon
  };

  // Resetting Search Field Handler
  const resetSelectedValue = () => {
    if (searchText.trim().length > 0 || searchTextTemplate.trim().length > 0) {
      setSearchText("");
      setSearchTextTemplate("")
      setEnableResetBtn(false);
      setLoading(true);
    }
  };

  // Press Enter, Search Field Handler  
  const handleEnterKeypress = (event) => {
    if (searchText.trim().length > 0) {
      if (event.key === "Enter") {
        setEnableResetBtn(true);
        setLoading(true);
        getModuleContentDetails();
      }
    }
  };

  // Search Field Handler
  const searchHandler = () => {
    if (searchText.trim().length > 0) {
      setEnableResetBtn(true);
      setLoading(true);
      getModuleContentDetails(); // Api calling on search 
    }
  };

  // Pagination api
  const fetchMore = (page) => {
    setPage(page);
    // const getModuleContentDetails = () => {
    const payload = {
      productName: localdata?.brand?.name,
      countryName: localdata?.market?.name,
      searchText: searchText,
      topicName: "",
      subtopicName: "",
      segmentNames: [],
      page: page,
    };

    getmmModules(payload, (response, err, ErrorCode) => {
      setLoading(true);
      if (err) {
        setLoading(false);
        console.log("search module error", err);
        // toastError();
      } else {
        setLoading(false);
        const data = response?.data?.data || [];
        const listData = data.filter(li => li.mlrStatus === 'Available for Use');
        
        if(response.data.totalElements <= [...moduleCardList, ...listData].length) {
          setHasMore(false);
        } else if(response.data.totalElements >= [...moduleCardList, ...listData].length) {
          setHasMore(true);
        }
        setModuleCardList([...moduleCardList, ...listData]);
        setModuleDetails([...moduleCardList, ...listData]);
        setSearchedData([...moduleCardList, ...listData]);
      }
    });
    // }
  };

  // Close View card
  const closeCardDetailsModal = () => {
    setIsPopupVisible(false);
  };

  const templateListUI = (props, option, { selected }) => {
    const { key, ...optionProps } = props;
    return (
      <li {...props} className="dropdown-list-css">
        <span>{option.name || option}</span>
      </li>
    );
  };

  const fetchMoreTemplate = (createdby, skipRange, moreData, expired) => {
    const countryName = localdata?.market?.name;
    prevSearchTextTemplate.current = searchTextTemplate.trim();
        setLoading(true);
          let searchPayload = {
            searchInput: searchTextTemplate,
            brand: localdata?.brand?._id,
            market: localdata?.market?._id, //marketID === undefined ? "" : marketID._id,
            type: 1,
            skip: skipRange,
            limit: 100,
            created: createdby,
            expired: false,
            mlrStatus: countryName.toUpperCase() === "GLOBAL"?'GRC Process Complete':'Approved for Use'
          };
          searchForDetails(searchPayload, (response, err, errorCode) => {
            if (err) {
              setLoading(false);
             // toast.error("Failed to fetch ");
            } else {
              const data = response.data?.response?.decks;
              let totalData = 0;
              if (moreData) {
                totalData = [...showFetchedResults, ...data];
              } else {
                totalData = [...data];
              }
              if (response.data.response?.totalCount <= totalData.length) {
                setHasMoreTemplate(false);
                setLoading(false);
              } else if (response.data?.response?.totalCount >= totalData.length) {
                setHasMoreTemplate(true);
              }
              setshowFetchedResults(totalData);
              setSkipRange(skipRange + limit);
              setLoading(false);
            }
          });
        }

  const searchTemplateHandler = (e) => {
    setSearchTextTemplate(e.target.value)
  }

  const clearField = () => {
    setSearchTextTemplate('')
    setEnableResetBtn(false)
  }

  const getTemplate = (event, action) => {
    if ((searchTextTemplate.trim().length > 0) && 
      ((action == "key" && event.key === "Enter") || action === "click")) {
     setEnableResetBtn(true)
      fetchMoreTemplate('all', 0, false, false)
    }

  }

  useEffect(() => {
    if (searchTextTemplate.trim() === "" && prevSearchTextTemplate.current !== "") {
      fetchMoreTemplate('all', 0, false, false)
      setEnableResetBtn(false)
    }
  },[searchTextTemplate]);

  useEffect(() => {
    getModuleContentMMDetails();
  }, []);

  // Get All MM Data
   const getModuleContentMMDetails = () => {
          const payload = {
            productName: localdata?.brand?.name,
            countryName: localdata?.market?.name,
            searchText: "",
            topicName: "",
            subtopicName: "",
            segmentNames: [],
            page: 0,
          };
      
          prevSearchText.current = "";

          getmmModules(payload, (response, err, ErrorCode) => {
            setLoading(true);
            if (err) {
              setLoading(false);
              console.log("search module error", err);
              // toastError();
            } else {
              const data = response?.data?.data || [];
              const listData = data.filter(li => li.mlrStatus === 'Available for Use');
              
              setModuleData(listData);
              setLoading(false);
            }
          });
        };

  // Filtering based on search data and showing that particular card
  const filteredData = moduleCardList?.filter(item1 => 
    searchedData.some(item2 => item2.moduleDamName === item1.moduleDamName)
  );

  return (
    <>
      {loading && (
        <CircularProgressBar isloading={loading} setIsloading={setLoading} />
      )}
      <div className="module-content-main">
        <div className="module-content-select-module">
          {closeTootltipTitle && <div className="d-flex module-content-tooltip">
                  <p>Associated module(s) from other topics have been added based on defined business rule(s)</p>
                  <img src={CrossIcon} alt="" width={18} onClick={closeTootltip} height={18} className="img-fluid"/>
                  <div className="tooltip-arrow"></div>
                </div>}
          <div className="d-flex align-items-center justify-content-between">
            {!modulePage && <h2 className="module-content-select-module-text">
              {switchCustomJs
                ? "View Business Rules associated with Modules"
                : `Select one or more Module (${moduleCardList.length})`}
            </h2>}
            {!modulePage && <div className="module-content-toggle d-flex align-items-center ">
              <label className="toggle-label">Show All Selected</label>
              <label class="toggle-switch-btn">
                <input
                  type="checkbox"
                  checked={switchCustomJs}
                  name="switchToggle"
                  onClick={() =>
                    selectedModuleIds.length > 0 &&
                    setSwitchCustomJs(!switchCustomJs)
                  }
                />
                <span
                  class={`toggle-switch switch-round ${
                    selectedModuleIds.length > 0 ? "toggle-btn-on" : ""
                  }`}
                ></span>
              </label>
            </div>}
            {modulePage && <h2 className="module-content-select-module-text">
              Select one Template {`(${showFetchedResults.length})`}
            </h2>}
          </div>
        </div>
        {!switchCustomJs && (
          <div>
            <div className="module-content-dropdown">
              <div className="module-content-dropdown-list">
                <TextFields
                  disabled={true}
                  width="160px"
                  height="42px"
                  id="filled-disabled"
                  label="Product"
                  // defaultValue="Biktarvy11"
                  defaultValue={localdata?.brand?.name}
                  key={localdata?.brand?.name}
                  variant="filled"
                  className="module-content-primary-product-field"
                />
              </div>
              <div className="module-content-dropdown-list">
                <TextFields
                  disabled={true}
                  id="filled-disabled"
                  label="Country"
                  defaultValue={localdata?.market?.name}
                  key={localdata?.market?.name}
                  variant="filled"
                  className="module-content-primary-product-field"
                />
              </div>
              {false && (<><div style={{ width: "200px" }}>
                <SelectAutoComplete
                  options={[brands]}
                  disableValue={false}
                  value={""}
                  label="Topic"
                  required={true}
                  renderOption={templateListUI}
                  //onChange={handleFieldChanges}
                />
              </div>
              <div style={{ width: "200px" }}>
                <SelectAutoComplete
                  options={[]}
                  disableValue={true}
                  value={""}
                  label="Sub-Topic"
                  required={true}
                  renderOption={templateListUI}
                  //onChange={handleFieldChanges}
                />
              </div>
              <div style={{ width: "200px" }}>
                <SelectAutoComplete
                  options={[brands]}
                  disableValue={false}
                  value={""}
                  label="Segment"
                  required={true}
                  renderOption={templateListUI}
                  //onChange={handleFieldChanges}
                />
              </div></>)}

              <div className="module-content-dropdown-list" style={{display:'flex', flexGrow:'1'}}>
{!modulePage && <SearchTextField
                  searchHandler={searchHandler}
                  handleEnterKeypress={handleEnterKeypress}
                  searchText={searchText}
                  cancelSearchField={cancelSearchField}
                  searchfieldsHandler={searchfieldsHandler}
                />}
                {modulePage && <SearchTextFieldTemplate
                  onChangeText={searchTemplateHandler}
                  searchTextTemplate={searchTextTemplate}
                  removeText={clearField}
                  onSearch={getTemplate}
                  setSearchTextTemplate={setSearchTextTemplate}
                />}
              </div>
              <button
                className={`module-content-reset-button 
                        ${
                          enableResetBtn
                            ? "module-content-active-reset-button"
                            : "module-content-deactive-reset-button"
                        }`}
                disabled={enableResetBtn === true ? false : true}
                onClick={resetSelectedValue}
              >
                RESET FILTERS
              </button>
            </div>
            {(!modulePage) && <div className={`${moduleCardList?.length < 1 ? 'noContent':''}`}>
              {moduleCardList?.length >0 && <InfiniteScroll
                dataLength={moduleCardList.length}
                next={() => fetchMore(page + 1)}
                hasMore={hasMore}
                scrollableTarget="scrollableDivModule"
                ref={infinteScrollRef}
                // loader={<h4>Loading...</h4>}
                scrollThreshold={0.9}
              >
                <div className="module-content-card-parent-div" id="scrollableDivModule">
                  <div className="module-content-card-child-div">
                    {filteredData &&
                      filteredData?.map((moduleList) => (
                        <ModuleListCard
                          disabledMustExistModules={disabledMustExistModules}
                          disabledModules={disabledModules}
                          getModuleStyle={getModuleStyle}
                          selectedModuleIds={selectedModuleIds}
                          selectedNextModuleList={selectedNextModuleList}
                          handleViewClick={handleViewClick}
                          handleCardClick={handleCardClick}
                          moduleList={moduleList}
                        />
                      ))}
                  </div>
                </div>
                {/* <div className='d-flex flex' style={{gap: "20px", flexWrap: "wrap", overflowX: "auto", maxHeight: "calc(100vh - 220px)", padding: "16px 42px 0px 42px"}}>
                            {moduleCardList && moduleCardList?.map(moduleList => <ModuleListCard disabledMustExistModules={disabledMustExistModules} disabledModules={disabledModules} getModuleStyle={getModuleStyle} selectedModuleIds={selectedModuleIds} selectedNextModuleList={selectedNextModuleList} handleViewClick={handleViewClick} handleCardClick={handleCardClick} moduleList={moduleList}/>)}
                        </div> */}
              </InfiniteScroll>}
               {/* && searchText.length > 0 */}
              {moduleCardList?.length <= 0 && (
                <div className="d-flex align-items-center justify-content-center">
                  <img src={NoModuleFound} />
                </div>
              )}
            </div>}
            {modulePage && <div className={`${showFetchedResults?.length < 1 ? 'noContent':''}`}>
              <InfiniteScroll
                dataLength={showFetchedResults.length}
                next={() => fetchMoreTemplate('all', skipRange, true, false)}
                hasMore={hasMoreTemplate}
                scrollableTarget="scrollableDivTemplate"
                ref={infinteScrollRef}
                // loader={<h4>Loading...</h4>}
                scrollThreshold={0.9}
              >
                {showFetchedResults?.length > 0 && <div className="module-content-card-parent-div" id="scrollableDivTemplate">
                  <div className="module-content-card-child-div">
                    {showFetchedResults && showFetchedResults.map((cardData, index) => (
                      <SelectTemplateCard
                        cardData={cardData}
                        imageKey={index}
                        templateSelected={templateSelected}
                        setTemplatedSelected={setTemplatedSelected}
                        showFetchedResults={showFetchedResults}
                        setshowFetchedResults={setshowFetchedResults}
                        setPayloadData={setPayloadData}
                        payloadData={payloadData}
                      />
                    ))}
                  </div>
                  
                </div>}
              </InfiniteScroll>
              {showFetchedResults?.length < 1 && (
                <div className="d-flex align-items-center justify-content-center">
                  <img src={NoResultsFound} />
                </div>
              )}
            </div>}
          </div>
        )}
        {selectedModuleIds.length > 0 && switchCustomJs && (
          <div>
            <SelectedModuleModal
              selectedModuleIds={selectedModuleIds}
              moduleCardList={moduleCardList}
              localdata={localdata}
              moduleData={moduleData}
            />
          </div>
        )}
      </div>
      {/* {isPopupVisible && (
        <ModuleContentCardDetailsModal
          cradDetails={cradDetails}
          isPopupVisible={isPopupVisible}
          closeCardDetailsModal={closeCardDetailsModal}
        />
      )} */}
         {isPopupVisible && (
        <ModuleView
        modulePreviewData={cradDetails}
        modulePreviewOpen={isPopupVisible}
        setModulePreviewOpen={closeCardDetailsModal}
        />
      )}


    </>
  );
};

export default ModuleContent;
